// extracted by mini-css-extract-plugin
export default {"order_header":"Order_order_header__X8xy7","order_number":"Order_order_number__SXJtj","order_flex":"Order_order_flex__51BJF","order_cont":"Order_order_cont__Gel08"};